// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Pow from "../lib/Pow.js";
import * as React from "react";
import * as Preact from "../bindings/Preact.js";
import * as QRUtils from "../lib/QRUtils.js";
import * as GunHelpers from "../lib/GunHelpers.js";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

function validateStoreName(name) {
  let trimmed = name.trim();
  if (trimmed.length < 1) {
    return "Store name is required";
  } else if (trimmed.length > 50) {
    return "Store name must be 50 characters or less";
  } else if (/<script|javascript:|on\w+=/i.test(trimmed)) {
    return "Invalid characters in store name";
  } else {
    return;
  }
}

function Landing$LoadingAnimation(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: "🎫",
            className: "ticket-front"
          }),
          className: "ticket-spinner"
        }),
        className: "spinner-container"
      }),
      JsxRuntime.jsx("p", {
        children: "Creating your queue...",
        className: "loading-text"
      }),
      JsxRuntime.jsx("p", {
        children: "Generating secure keys (this takes a few seconds)",
        className: "loading-subtext"
      })
    ],
    className: "loading-animation",
    "data-testid": "loading-animation"
  });
}

let LoadingAnimation = {
  make: Landing$LoadingAnimation
};

function Landing(props) {
  let match = React.useState(() => "");
  let setStoreName = match[1];
  let storeName = match[0];
  let match$1 = React.useState(() => {});
  let setError = match$1[1];
  let error = match$1[0];
  let match$2 = React.useState(() => false);
  let setIsLoading = match$2[1];
  let isLoading = match$2[0];
  let match$3 = React.useState(() => {});
  let setCreatedStore = match$3[1];
  let createdStore = match$3[0];
  let match$4 = React.useState(() => "");
  let setQrCodeUrl = match$4[1];
  let qrCodeUrl = match$4[0];
  let handleCreateStore = async e => {
    e.preventDefault();
    let validationError = validateStoreName(storeName);
    if (validationError !== undefined) {
      return setError(param => validationError);
    }
    setError(param => {});
    setIsLoading(param => true);
    try {
      GunHelpers.initGun(undefined);
      await Pow.generateKeyPair();
      let result = await GunHelpers.createStore(storeName.trim(), undefined);
      let customerUrl = QRUtils.generateCustomerURL(result.storeId);
      let qrDataUrl = await QRUtils.generateQRCode(customerUrl, undefined);
      setQrCodeUrl(param => qrDataUrl);
      setCreatedStore(param => ({
        storeId: result.storeId,
        adminId: result.adminId,
        store: result.store,
        customerUrl: customerUrl,
        adminUrl: QRUtils.generateAdminURL(result.adminId)
      }));
    } catch (raw_err) {
      let err = Primitive_exceptions.internalToException(raw_err);
      if (err.RE_EXN_ID === "JsExn") {
        let err$1 = err._1;
        console.error(err$1);
        let msg = Stdlib_Option.getOr(Stdlib_JsExn.message(err$1), "Failed to create queue. Please try again.");
        setError(param => msg);
      } else {
        throw err;
      }
    }
    return setIsLoading(param => false);
  };
  let handleDownloadQR = _e => {
    if (createdStore === undefined) {
      return;
    }
    let safeName = createdStore.store.name.replace(/[^a-zA-Z0-9]/g, "-");
    QRUtils.downloadQRCode(qrCodeUrl, safeName + `-qrcode.png`);
  };
  let copyAdminUrl = _e => {
    if (createdStore !== undefined) {
      Stdlib_Promise.$$catch(navigator.clipboard.writeText(createdStore.adminUrl), param => {
        console.error("Failed to copy");
        return Promise.resolve();
      });
      return;
    }
  };
  if (createdStore !== undefined) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("h1", {
              children: "🎉 Queue Created!",
              className: "page-title"
            }),
            JsxRuntime.jsx("p", {
              children: createdStore.store.name,
              className: "page-subtitle"
            })
          ],
          className: "page-header"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("input", {
              "data-testid": "customer-url",
              type: "hidden",
              value: createdStore.customerUrl
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h2", {
                  children: "Customer QR Code"
                }),
                JsxRuntime.jsx("p", {
                  children: "Print this and display at your counter",
                  className: "text-muted"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("a", {
                    children: "🔗 Open Queue Page",
                    className: "customer-url-link",
                    "data-testid": "customer-url-link",
                    href: createdStore.customerUrl,
                    target: "_blank"
                  }),
                  className: "customer-url-container mt-2 mb-2"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("img", {
                    className: "qr-code-image",
                    "data-testid": "qr-code",
                    alt: "Queue QR Code",
                    src: qrCodeUrl
                  }),
                  className: "qr-code-container"
                }),
                JsxRuntime.jsx("button", {
                  children: "📥 Download QR Code",
                  className: "btn btn-primary mt-2",
                  "data-testid": "download-qr",
                  onClick: handleDownloadQR
                })
              ],
              className: "qr-section",
              "data-testid": "qr-section"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h2", {
                  children: "Admin URL"
                }),
                JsxRuntime.jsx("p", {
                  children: "Save this link to manage your queue",
                  className: "text-muted"
                }),
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("input", {
                      className: "admin-url-input",
                      "data-testid": "admin-url",
                      readOnly: true,
                      type: "text",
                      value: createdStore.adminUrl
                    }),
                    JsxRuntime.jsx("button", {
                      children: "📋 Copy",
                      className: "btn btn-secondary",
                      "data-testid": "copy-admin-url",
                      onClick: copyAdminUrl
                    })
                  ],
                  className: "admin-url-container"
                }),
                JsxRuntime.jsx("p", {
                  children: "⚠️ Save this URL! It's the only way to access your admin panel.",
                  className: "warning-text mt-2"
                })
              ],
              className: "admin-section mt-4"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h3", {
                  children: "Next Steps"
                }),
                JsxRuntime.jsxs("ol", {
                  children: [
                    JsxRuntime.jsx("li", {
                      children: "Print the QR code and display it at your counter"
                    }),
                    JsxRuntime.jsx("li", {
                      children: "Bookmark the admin URL to manage your queue"
                    }),
                    JsxRuntime.jsx("li", {
                      children: "Customers scan the QR code to take a number"
                    })
                  ]
                })
              ],
              className: "next-steps mt-4"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("a", {
                children: "Go to Admin Panel →",
                className: "btn btn-primary",
                "data-testid": "go-to-admin",
                href: createdStore.adminUrl
              }),
              className: "actions mt-4"
            })
          ],
          className: "container"
        })
      ],
      className: "page",
      "data-testid": "landing-page",
      id: `store-` + createdStore.storeId
    });
  } else {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("h1", {
              children: "🎫 Take a Number",
              className: "page-title"
            }),
            JsxRuntime.jsx("p", {
              children: "Queue management for your store. No app needed.",
              className: "page-subtitle"
            })
          ],
          className: "page-header"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            isLoading ? JsxRuntime.jsx(Landing$LoadingAnimation, {}) : JsxRuntime.jsxs("form", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("label", {
                        children: "Store Name",
                        className: "form-label",
                        htmlFor: "storeName"
                      }),
                      JsxRuntime.jsx("input", {
                        className: "form-input",
                        "data-testid": "store-name-input",
                        id: "storeName",
                        disabled: isLoading,
                        maxLength: 50,
                        placeholder: "e.g., Joe's Bakery",
                        type: "text",
                        value: storeName,
                        onInput: e => setStoreName(param => e.target.value)
                      }),
                      JsxRuntime.jsx("p", {
                        children: storeName.length.toString() + `/50 characters`,
                        className: "form-hint"
                      })
                    ],
                    className: "form-group"
                  }),
                  error !== undefined ? JsxRuntime.jsx("div", {
                      children: error,
                      className: "error-message",
                      "data-testid": "error-message"
                    }) : null,
                  JsxRuntime.jsx("button", {
                    children: "Create My Queue",
                    className: "btn btn-primary btn-full",
                    "data-testid": "create-queue-btn",
                    disabled: isLoading || storeName.trim().length === 0,
                    type: "submit"
                  })
                ],
                className: "create-form",
                onSubmit: e => {
                  handleCreateStore(e);
                }
              }),
            isLoading ? null : JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("h3", {
                    children: "How it works"
                  }),
                  JsxRuntime.jsxs("ul", {
                    children: [
                      JsxRuntime.jsx("li", {
                        children: "✨ Create your queue in seconds"
                      }),
                      JsxRuntime.jsx("li", {
                        children: "📱 Customers scan QR code to take a number"
                      }),
                      JsxRuntime.jsx("li", {
                        children: "🔔 Real-time updates for everyone"
                      }),
                      JsxRuntime.jsx("li", {
                        children: "🚫 No app download required"
                      })
                    ],
                    className: "feature-list"
                  })
                ],
                className: "features mt-4"
              })
          ],
          className: "container"
        })
      ],
      className: "page",
      "data-testid": "landing-page"
    });
  }
}

function expose() {
  Preact.setWindowProperty("Landing", Landing);
}

let make = Landing;

export {
  validateStoreName,
  LoadingAnimation,
  make,
  expose,
}
/* react Not a pure module */
